import React, { useContext } from 'react';
import AuthContext from '../context/AuthContext';
import './LoginPage.css';
import logo from './bitmap.png';

const LoginPage = () => {
  let { loginUser } = useContext(AuthContext);

  return (
    <div class="login-page-area">
      <div class="form-container">
        <img src={logo} alt="connote Logo" class="logo" />
        <form class="login-form" onSubmit={loginUser}>
          <h1>conNote</h1>
          <input type="text" name="username" placeholder="Username" required />
          <input
            type="password"
            name="password"
            placeholder="Password"
            required
          />
          <button type="submit" value="Login">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
